import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { ConnectionBadge, Badge, types, helpers } from "@vilocnv/allsetra-core";
import {
  AssignedUsersCardContainer,
  CardText
} from "../ObjectAssignedUsersCard/ObjectAssignedUsersCard.styled";

import { DeviceIcon } from "assets/icons";
import LabelsBatteryInstallationDates from "./LabelsBatteryInstallationDates";
import IconBatteryLevel from "./IconBatteryLevel";
import SectionSubscriptions from "./SectionSubscriptions";
import { selectSubscriptionsState } from "domain/subscriptions/store/selectors/subscriptions.selector";
import { useAppSelector } from "hooks";
import { useTranslation } from "react-i18next";

export interface ObjectDevicesCardProps {
  device: types.IDevice;
}

const ObjectDevicesCard: FC<ObjectDevicesCardProps> = ({ device }) => {
  const { subscriptions } = useAppSelector(selectSubscriptionsState);
  const { t } = useTranslation();

  const getObjectDeviceSubscription = (deviceUniqueId: string | undefined) => {
    if (!deviceUniqueId) return undefined;

    const subscription =
      subscriptions.find(
        (sub: any) => sub?.device?.uniqueId === deviceUniqueId
      ) || null;

    return subscription;
  };

  const subscriptionName =
    getObjectDeviceSubscription(device.uniqueId)?.subscription?.name ||
    undefined;

  return (
    <AssignedUsersCardContainer>
      <Stack spacing={2}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            {device?.object?.objectType?.icon?.length ? (
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}/icons/${device.object.objectType.icon.uniqueId}/file?X-Subscription=${process.env.REACT_APP_API_HEADER_SUBSCRIPTION}`}
                alt="Icon"
                width="16px"
                height="16px"
              />
            ) : (
              <DeviceIcon />
            )}
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#1D1F2B"
              }}
            >
              {device.serialNumber ?? "N/A"}
            </Typography>
          </Stack>

          <Badge
            colorScheme={helpers.getDeviceBadgeColorOnStatus(
              device?.status || "N/A"
            )}
          >
            {device?.status || "N/A"}
          </Badge>
        </Stack>

        {/* //removing the address for now */}
        {/* <CardText color={"#212B33"} fontWeight={"400"} fontSize={"12px"}>
          {device.location?.resolvedAddress ?? t("addressNotAvailable")}
        </CardText> */}

        <Stack direction={"row"} alignItems={"center"} spacing={2}>
          <ConnectionBadge
            status={device.isOnLine ? "online" : "offline"}
          ></ConnectionBadge>
          {/* @ts-ignore */}
          {device?.deviceType?.type === 4 && (
            <IconBatteryLevel
              installationDate={device.installationDate}
              lifetimeDays={3 * 365}
            />
          )}
        </Stack>

        {/* @ts-ignore */}
        {device?.deviceType?.type === 4 && (
          <LabelsBatteryInstallationDates
            installationDate={device.installationDate}
            lifetimeDays={3 * 365}
          />
        )}

        <SectionSubscriptions subscriptionName={subscriptionName} />
      </Stack>
    </AssignedUsersCardContainer>
  );
};

export default ObjectDevicesCard;
